
import Scroller from 'vux/src/components/scroller/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {eventBus} from '../../../eventbus'
export default {
data () {
return {
caseId: this.$route.params.caseid,
reportId: this.$route.params.reportid,
diagCropMin: '',
diagCropMax: '',
cropList: [],
cropAddrArray: [],
materialList: [],
materialArray: [],
samplePicShow: null,
eyeSeeShow: null,
eyeSeeTitle: '',
glassSeeShow: null,
glassSeeTitle: '',
diagnoseResultShow: null,
diagnoseResultTitle: '',
oneKnowledge: [],
twoKnowledge: [],
threeKnowledge: [],
oneValue: [''],
twoValue: [''],
threeValue: [''],
oneShow: true,
twoShow: true,
threeShow: true,
iconfont: ['iconfont', 'tissue-adopt-report-icon-padding'],
iconDown: 'icon-circle-down',
iconUp: ['icon-circle-up', 'tissue-adopt-report-blue'],
innerCtn: 'tissue-adopt-report-innerCtn',
innerCtnBig: 'tissue-adopt-report-innerCtn-big',
returnEyeSee: '',
returnGlassSee: '',
returnDiagnoseResult: '',
groupEyeSee: '',
groupGlassSee: '',
groupDiagnoseResult: '',
tipShow: false,
tip: '',
clickCount: 0,
fullClickShow: false,
partClickShow: false
}
},
components: { Scroller, Checker, CheckerItem, XTextarea, Group, Picker, GroupTitle, XButton, PopupRadio, XDialog, Flexbox, FlexboxItem },
beforeMount () {
this.$vue = this
this.getPageData()
},
methods: {
async getPageData () {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('ID', this.reportId)
let suc = await this.$http.post(this.$vue.getData('ADOPT_REPORT'), params)
if (suc.data.result === '1') {
this.diagCropMin = suc.data.data.pdModelConfig.DIAGNOSE_CROP_MIN
this.diagCropMax = suc.data.data.pdModelConfig.DIAGNOSE_CROP_MAX
this.samplePicShow = suc.data.data.pdModelConfig.SAMPLE_PIC_SHOW
this.eyeSeeShow = suc.data.data.pdModelConfig.EYE_SEE_SHOW
this.eyeSeeTitle = suc.data.data.pdModelConfig.EYE_SEE_TITLE
this.glassSeeShow = suc.data.data.pdModelConfig.GLASS_SEE_SHOW
this.glassSeeTitle = suc.data.data.pdModelConfig.GLASS_SEE_TITLE
this.diagnoseResultShow = suc.data.data.pdModelConfig.DIAGNOSE_RESULT_SHOW
this.diagnoseResultTitle = suc.data.data.pdModelConfig.DIAGNOSE_RESULT_TITLE
this.cropList = suc.data.data.cropList
this.cropAddrArray = suc.data.data.cropAddrArray
this.groupEyeSee = suc.data.data.groupReport.groupEyeSee
this.returnEyeSee = suc.data.data.returnReport.returnEyeSee
this.twoValue = suc.data.data.returnReport.returnEyeSee.length === 0 ? [''] : suc.data.data.returnReport.returnEyeSee
this.groupGlassSee = suc.data.data.groupReport.groupGlassSee
this.returnGlassSee = suc.data.data.returnReport.returnGlassSee
this.threeValue = suc.data.data.returnReport.returnGlassSee.length === 0 ? [''] : suc.data.data.returnReport.returnGlassSee
this.groupDiagnoseResult = suc.data.data.groupReport.groupDiagnoseResult
this.returnDiagnoseResult = suc.data.data.returnReport.returnDiagnoseResult
this.oneValue = suc.data.data.returnReport.returnDiagnoseResult.length === 0 ? [''] : suc.data.data.returnReport.returnDiagnoseResult
this.oneKnowledge = suc.data.data.oneKnowledge
this.twoKnowledge = suc.data.data.twoKnowledge
this.threeKnowledge = suc.data.data.threeKnowledge
}
},
oneChange () {
this.returnDiagnoseResult = this.oneValue.toString().replace(/,/g, '')
},
twoChange () {
this.returnEyeSee = this.twoValue.toString().replace(/,/g, '')
},
threeChange () {
this.returnGlassSee = this.threeValue.toString().replace(/,/g, '')
},
fullAdopt () {
if (this.clickCount === 0) {
this.fullClickShow = true
this.returnEyeSee = JSON.parse(JSON.stringify(this.groupEyeSee))
this.twoValue = this.returnEyeSee
this.returnGlassSee = JSON.parse(JSON.stringify(this.groupGlassSee))
this.threeValue = this.returnGlassSee
this.returnDiagnoseResult = JSON.parse(JSON.stringify(this.groupDiagnoseResult))
this.oneValue = this.returnDiagnoseResult
this.clickCount++
}
},
partAdopt () {
if (this.clickCount === 0) {
this.partClickShow = true




this.returnGlassSee = (this.returnGlassSee + ',' + this.groupGlassSee).split(',')
this.threeValue = this.returnGlassSee
this.returnDiagnoseResult = (this.returnDiagnoseResult + ',' + this.groupDiagnoseResult).split(',')
this.oneValue = this.returnDiagnoseResult
this.clickCount++
}
},
async finishDiagnose (method) {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('cropAddrArray', this.cropAddrArray)
params.append('materialArray', this.materialArray)
params.append('samplePicShow', this.samplePicShow)
params.append('eyeSee', this.returnEyeSee)
params.append('glassSee', this.returnGlassSee)
params.append('diagnoseResult', this.returnDiagnoseResult)
params.append('method', method)
params.append('TO_ADOPT', 1)
params.append('GROUP_REPORT_ID', this.reportId)

eventBus.$emit('showLoading', true, '加载中')
let suc = await this.$http.post(this.$vue.getData('FINISH_DIAGNOSE'), params)
if (suc.data.result === '1') {

this.$router.push({ name: 'reportdetail', params: {data: suc.data.data, finishDiagnose: true} })
}

eventBus.$emit('showLoading', false)
},
back () {

}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/report/tissueAdoptReport.vue